<template>
  <div class='top-list'>
    <div class="contentBox">
      <div class="pd25">
        <mTitle :isShowRightText="false" :title="'企业风采'" class="pcbox"></mTitle>

        <mTitle :isShowRightText="false" :isPaddingLeft="true" :title="'企业风采'" class="mobileBox"></mTitle>
      </div>
      <!-- <div class="titleBox">333</div> -->
      <!-- <div class="aligCenter">
        <img class="imgView" src="https://ai-public.mastergo.com/ai/img_res/16c7529e239d0e934cc8981a5459fa44.jpg" alt="">
      </div> -->
      <div class="contentDetail ql-editor">
          <div v-html="processedRichText" class="aabb"></div>

          </div>
      <!-- <div class="contentDetail">
          <p>绿采网是一家致力于推动绿色采购与可持续发展的创新型企业。公司以“绿色、环保、责任”为核心价值观，专注于为企业、政府机构及个人用户提供高效、透明的绿色采购解决方案。通过整合优质资源、优化供应链管理，绿采网帮助客户实现环保目标，降低碳足迹，同时提升经济效益。 核心业务</p>
        <p>核心业务</p>
        <p>1. **绿色供应链管理** </p>
        <p>绿采网为企业提供从原材料采购到产品交付的全流程绿色供应链服务，确保每个环节符合环保标准，助力企业实现可持续发展目标.</p>

        <p>2. **环保产品采购平台**</p>
        <p>绿采网搭建了线上绿色采购平台，汇聚了众多经过严格认证的环保产品，涵盖办公用品、建筑材料、清洁能源设备等多个领域，为用户提供一站式绿色采购服务</p>

        <p>3. **碳足迹评估与优化**</p>
        <p>公司提供专业的碳足迹评估服务，帮助企业识别碳排放热点，并提供优化方案，助力企业实现碳中和目标。</p>
        <p>4. **绿色认证与咨询服务**</p>
        <p>绿采网为企业提供绿色产品认证、环保政策解读及可持续发展战略咨询，帮助客户在市场竞争中占据绿色先机。</p>

        <p>### 公司优势</p>
        <p>- **专业团队**：绿采网拥有一支经验丰富的环保专家团队，深谙绿色采购与可持续发展领域的前沿趋势。</p>
        <p>- **技术驱动**：通过大数据、人工智能等技术手段，绿采网为客户提供精准的采购分析与优化建议。</p>
        <p>- **资源整合**：与国内外多家环保认证机构、绿色供应商建立了长期合作关系，确保资源的高效整合与利用。</p>
        <p>- **社会责任**：绿采网始终践行社会责任，积极参与环保公益事业，推动绿色理念的普及与实践。</p>

        <p>### 愿景与使命</p>
        <p>绿采网的愿景是成为全球领先的绿色采购服务平台，推动绿色消费与可持续发展理念的普及。我们的使命是通过创新的绿色采购解决方案，助力客户实现经济效益与环境效益的双赢，为构建绿色地球贡献力量。</p>
        </div> -->


      <div>
       
      </div>
    </div>
    
  </div>
</template>

<script>
import mTitle from "@/components/TitleHead/index.vue";
export default {
  name: 'Toplist',
  components: { mTitle },
  data() {
    return {
      richText:'',
      title:'',

    }
  },
  computed:{
    processedRichText(){
          // 创建一个临时的 div 元素，用来处理 richText 内容
          const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.richText;
      
      // 查找所有的 table 元素
      const tables = tempDiv.querySelectorAll('table');
      if(tables.length>0){
        tables.forEach(table => {
        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('table-wrapper'); // 可以添加自定义的类
        table.parentNode.insertBefore(wrapperDiv, table);
        wrapperDiv.appendChild(table);
      });
      }

      // 返回处理后的 HTML 字符串
      return tempDiv.innerHTML;
    }
  },
  mounted() {
      this.getDetail()
} ,methods: {
  getDetail(){
         this.$API.getInfoDetail().then(res => {
      if (res.code === 200) {
        this.richText = res.data.content
        this.title = res.data.title
      }
    })
    },
    toDetail(xid){
      this.$router.push({path:'/playlistDetail',query: { id: xid }})
    }
  },
}
</script>

<style scoped lang='less'>
::v-deep .table-wrapper{
  max-width: 95%;
  overflow-x: auto;
}
  ::v-deep .aabb img{
      max-width: 95%;
    }
    ::v-deep .aabb table{
      
      border-collapse: collapse;
    }
    ::v-deep .aabb table p{
      margin: 0;
      line-height: 17px;
    }
    ::v-deep td,th{
      border: 1px solid #DDD;
    }
//移动端
@media (max-width: 768px) {

  .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
line-height: 30px;
text-align: left;
font-style: normal;
text-transform: none;
padding:10px;
    }
  .contentDetail{
    padding: 10px;

font-weight: 500;
font-size: 15px;
color: #222222;
line-height: 26px;
text-align: left;
font-style: normal;
text-transform: none;
  }
  .aligCenter{
  display: flex;
  justify-content: center;
}
  .pd25{
    padding-top: 10px;
  }
  .pcbox{
    display: none !important;
  }
  .contentBox{
  width: 363px;
  background: #fff;
  margin: 10px auto;
}
  .imgView{
width: 323px;
height: 215px;
margin-top:10px;
}
}
//pc端
@media (min-width: 769px) {
  .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
  }
  .mobileBox{
    display: none !important;
  }
  .aligCenter{
  display: flex;
  justify-content: center;
}
.contentDetail{
font-weight: 500;
font-size: 16px;
color: #222222;
line-height: 30px;
text-align: left;
font-style: normal;
text-transform: none;
padding:10px 25px 40px 25px;
}
.imgView{
width: 843px;
height: 562px;
}

.pd25{
  padding: 25px;
}
.top-list {
  width: 100%;
  min-height: calc(100vh - 200px);
  margin: 0 auto;
  background-color: #f5f5f5;
  margin-top: 10px;

}
.contentBox{
  width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 200px);
  background: #fff;
}
}

</style>